import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

import {
  Field,
  SideloadedMetadataLabels,
  XIFieldData,
} from '../providers/storage-api/field.service';

@Pipe({
  name: 'sideloadedLabel',
  standalone: false,
})
export class SideloadedLabelPipe implements PipeTransform {
  translocoService: TranslocoService = inject(TranslocoService);
  transform(value: Field, field: keyof SideloadedMetadataLabels, index = 0): string {
    if (!value.sideloaded || !value.sideloaded[field]?.length) {
      return value.description;
    }
    const locale = Object.keys(value.sideloaded[field][index].label.locales).find((key) =>
      key.includes(this.translocoService.getActiveLang())
    );

    return this.findLocaleAwareLabel(locale, index, value.sideloaded[field]);
  }

  private findLocaleAwareLabel(locale: string, index: number, arr: Array<XIFieldData>) {
    return arr[index].label.locales[locale] ?? arr[index].default;
  }
}
